import { createLookupStore, type LookupStore } from '../composables/useLookupStore';
import { fetchAllAuthUsers, type AuthUser } from './usersApi';

let _authUsers: LookupStore<AuthUser> | undefined;

export function getAuthUsersLookup(): LookupStore<AuthUser> {
  if (!_authUsers) {
    _authUsers = createLookupStore<AuthUser>(fetchAllAuthUsers, {
      idField: 'user_id',
      labelField: 'email',
    });
  }
  return _authUsers;
}
